import React, { useState } from 'react'
import { InputNumber, Tooltip, Button } from 'antd'
import { Input } from '@/ui'
import { isNumber } from '@/utils/utils'
import styles from './index.less'
import MinusOutlined from '@ant-design/icons/MinusOutlined'
import classNames from 'classnames'

export default ({
    value,
    onChange,
    placeholder,
    leftPlaceholder,
    rightPlaceholder,
    // eslint-disable-next-line no-unused-vars
    tip,
    // eslint-disable-next-line no-unused-vars
    allowClear = false,
    disabled = false,
    tooltip = false,
    tips,
    leftOnChangeFormat,
    rightOnChangeFormat,
    showStepper = false, // 展示步进器
    leftMin = Number.MIN_SAFE_INTEGER, // showStepper 为 true 有效（leftMin,leftMax,rightMin,rightMax）
    leftMax = Number.MAX_SAFE_INTEGER,
    rightMin = Number.MIN_SAFE_INTEGER,
    rightMax = Number.MAX_SAFE_INTEGER,
    obviousInterval = false, // 明显的中间区间横线
    precision,
    onPressEnter,
    isNeedNumber, // 需要返回的值 是number类型
    formatter,
    parser,
    intervalDisabled = true, // form rule不通过时disabled会影响样式
    label,
    ...restProps
}) => {
    const [leftFocus, setLeftFocus] = useState(false)
    const [rightFocus, setRightFocus] = useState(false)

    const changeHandle = (type, e) => {
        const targetValue = isNeedNumber ? e : `${e}`
        const event = showStepper
            ? {
                  persist: () => {},
                  preventDefault: () => {},
                  target: {
                      value: isNumber(e) ? targetValue : undefined
                  }
              }
            : e

        if (type === 'left') {
            onChange({
                ...value,
                leftValue: leftOnChangeFormat ? leftOnChangeFormat(event) : event.target.value
            })
        } else {
            onChange({
                ...value,
                rightValue: rightOnChangeFormat ? rightOnChangeFormat(event) : event.target.value
            })
        }
    }

    const pressEnter = (type, e) => {
        if (typeof onPressEnter !== 'function') {
            return
        }
        const event = e
        if (type === 'left') {
            onPressEnter({
                ...value,
                leftValue: leftOnChangeFormat ? leftOnChangeFormat(event) : event.target.value
            })
        } else {
            onPressEnter({
                ...value,
                rightValue: rightOnChangeFormat ? rightOnChangeFormat(event) : event.target.value
            })
        }
    }

    const InputComponent = showStepper ? InputNumber : Input

    const [leftTipVisible, setLeftTipVisible] = useState(false)
    const [rightTipVisible, setRightTipVisible] = useState(false)

    return (
        <div {...restProps} className={styles.selecteComponentBox}>
            <Tooltip overlay={null} title={tips} visible={leftFocus || rightFocus}>
                <Input.Group compact={!showStepper} className={classNames(styles.flex, styles.rangWrapper)}>
                    {label && <span className={styles.label}>{label}</span>}
                    <Tooltip
                        overlay={null}
                        title={value?.leftValue || null}
                        visible={tooltip && leftTipVisible && isNumber(value?.leftValue)}
                    >
                        <InputComponent
                            className={styles.siteInputLeft}
                            onChange={e => {
                                changeHandle('left', e)
                            }}
                            onPressEnter={e => {
                                pressEnter('left', e)
                            }}
                            onFocus={() => {
                                tips && setLeftFocus(true)
                            }}
                            onBlur={() => {
                                setTimeout(() => {
                                    tips && setLeftFocus(false)
                                }, 200)
                            }}
                            onMouseOver={() => {
                                setLeftTipVisible(true)
                            }}
                            onMouseLeave={() => {
                                setLeftTipVisible(false)
                            }}
                            value={value?.leftValue}
                            placeholder={leftPlaceholder || placeholder}
                            allowClear
                            disabled={disabled}
                            min={leftMin}
                            max={leftMax}
                            precision={precision}
                            formatter={formatter}
                            parser={parser}
                        />
                    </Tooltip>
                    {obviousInterval ? (
                        <Button icon={<MinusOutlined />} />
                    ) : (
                        <Input
                            className={classNames({
                                [styles.split]: true,
                                [styles.disabled]: disabled
                            })}
                            prefix={<div className={styles.prefix} />}
                            placeholder=""
                            disabled={intervalDisabled}
                            defaultValue=" "
                        />
                    )}
                    <Tooltip
                        overlay={null}
                        title={value?.rightValue || null}
                        visible={tooltip && rightTipVisible && isNumber(value?.rightValue)}
                    >
                        <InputComponent
                            className={classNames({
                                [styles.siteInputRight]: true,
                                [styles.borderLeftTransparent]: !showStepper
                            })}
                            onChange={e => {
                                changeHandle('right', e)
                            }}
                            onPressEnter={e => {
                                pressEnter('right', e)
                            }}
                            onFocus={() => {
                                tips && setRightFocus(true)
                            }}
                            onBlur={() => {
                                setTimeout(() => {
                                    tips && setRightFocus(false)
                                }, 200)
                            }}
                            onMouseOver={() => {
                                setRightTipVisible(true)
                            }}
                            onMouseLeave={() => {
                                setRightTipVisible(false)
                            }}
                            value={value?.rightValue}
                            placeholder={rightPlaceholder || placeholder}
                            allowClear
                            disabled={disabled}
                            min={rightMin}
                            max={rightMax}
                            precision={precision}
                            formatter={formatter}
                            parser={parser}
                        />
                    </Tooltip>
                </Input.Group>
            </Tooltip>
        </div>
    )
}
